import { render, staticRenderFns } from "./StepDistributeBalanceWealth.vue?vue&type=template&id=3d5707d1&scoped=true&"
import script from "./StepDistributeBalanceWealth.vue?vue&type=script&lang=ts&"
export * from "./StepDistributeBalanceWealth.vue?vue&type=script&lang=ts&"
import style0 from "./StepDistributeBalanceWealth.vue?vue&type=style&index=0&id=3d5707d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5707d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField})
